import axios from '../Axios';

class OrderService {
  async getOrders(filters = {}) {
    try {
      const response = await axios.get('/admin/order', {
        params: filters
      });
      return response.data.data;
    } catch (error) {
      console.error("Failed to fetch Orders:", error);
      throw error;
    }
  }

  async getOrder(id) {
    try {
      const response = await axios.get(`/admin/order/${id}`);
      console.log("Fetched order:", response);
      return response.data.data;
    } catch (error) {
      console.error("Failed to fetch order:", error);
      throw error;
    }
  }

  async updateOrder(id, data) {
    try {
      const response = await axios.put(`/admin/order/${id}`, data);
      return response.data.data;
    } catch (error) {
      console.error("Failed to update order:", error);
      throw error;
    }
  }
}

export default new OrderService(); 